module.exports = function playSample(sample) {
  window.Tone.start()
  if (sample) {
    if (sample.category === 'loop') {
      sample.file.loop = true
    }
    if (sample.file) {
      sample.file.stop()
      sample.file.start(0)
    }
  }
}
